import { render } from "./InitiativeJustificationMeasure.vue?vue&type=template&id=490a1770&scoped=true"
import script from "./InitiativeJustificationMeasure.vue?vue&type=script&lang=js"
export * from "./InitiativeJustificationMeasure.vue?vue&type=script&lang=js"

import "./InitiativeJustificationMeasure.vue?vue&type=style&index=0&id=490a1770&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490a1770"]])

export default __exports__